import { FormTemplateQuestionFieldOptionsValidityHintEnum } from 'graphql-common';
import { ChipTypes } from '@lib/components/Chip/Chip';

export default function getValidityHintOptions(
  skipOptions?: FormTemplateQuestionFieldOptionsValidityHintEnum[],
) {
  const options = [
    {
      labelKey: 'validity-hint-optimal',
      value: FormTemplateQuestionFieldOptionsValidityHintEnum.Success,
      color: ChipTypes.chipGreen,
      leftIcon: 'check_circle',
    },
    {
      labelKey: 'validity-hint-warning',
      value: FormTemplateQuestionFieldOptionsValidityHintEnum.Warning,
      color: ChipTypes.chipOrange,
      leftIcon: 'warning',
    },
    {
      labelKey: 'validity-hint-critical',
      value: FormTemplateQuestionFieldOptionsValidityHintEnum.Failure,
      color: ChipTypes.chipRed,
      leftIcon: 'error',
    },
  ];

  if (!skipOptions?.length) {
    return options;
  }

  return options.filter((option) => !skipOptions.includes(option.value));
}
